import { render, staticRenderFns } from "./EmpiresTable.vue?vue&type=template&id=5a6f9678&scoped=true&"
import script from "./EmpiresTable.vue?vue&type=script&lang=js&"
export * from "./EmpiresTable.vue?vue&type=script&lang=js&"
import style0 from "./EmpiresTable.vue?vue&type=style&index=0&id=5a6f9678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f9678",
  null
  
)

export default component.exports